import { SchemaField } from '@/contexts/ApplicationContext';
import { getLatestBookingDataSchema } from '@/services/asyncActions';
import { Language } from '@/types/forms/newApplicationFormTypes';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

export const fetchSchema = createAsyncThunk(
  'schema/fetchSchema',
  async (_, { rejectWithValue }) => {
    try {
      return await getLatestBookingDataSchema();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

interface SchemaState {
  schemaData: Record<string, SchemaField[]> | null;
  languageSchema: Language[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: SchemaState = {
  schemaData: null,
  languageSchema: null,
  loading: false,
  error: null,
};

const schemaSlice = createSlice({
  name: 'schema',
  initialState,
  reducers: {
    resetSchema: (state) => {
      state.schemaData = null;
      state.loading = false;
      state.error = null;
    },
    setLanguageSchema: (state, action: PayloadAction<Language[]>) => {
      state.languageSchema = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchema.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchSchema.fulfilled,
        (state, action: PayloadAction<Record<string, any>>) => {
          state.loading = false;
          state.schemaData = action.payload;
        }
      )
      .addCase(fetchSchema.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetSchema, setLanguageSchema } = schemaSlice.actions;
export default schemaSlice.reducer;
